<template>
    <section class="mb-8">
        <h4 class="text-slate-800 dark:text-slate-100 font-medium mb-4">Details</h4>
        <div class="grid grid-cols-3 grid-flow-row gap-4">
            <div class="col-span-1">
                <p class="text-slate-500 dark:text-slate-400 text-sm">Date</p>
            </div>
            <div class="col-span-2">
                <p class="text-slate-800 dark:text-slate-100 text-sm">
                    <span v-if="!hideSensitiveData">
                        {{ travelDate }}
                    </span>
                    <span v-else class="text-slate-400">Hidden</span>
                </p>
            </div>
            <div class="col-span-1">
                <p class="text-slate-500 dark:text-slate-400 text-sm">Location</p>
            </div>
            <div class="col-span-2">
                <p class="text-slate-800 dark:text-slate-100 text-sm">
                    {{ activeRedemption.other_location }}
                </p>
            </div>
            <div class="col-span-1">
                <p class="text-slate-500 dark:text-slate-400 text-sm">Travelers</p>
            </div>
            <div class="col-span-2">
                <p class="text-slate-800 dark:text-slate-100 text-sm">
                    {{ activeRedemption.number_of_travelers }}
                </p>
            </div>
        </div>
    </section>
</template>
<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';

const props = defineProps({
    activeRedemption: Object,
    isSharedView: {
        type: Boolean,
        default: false,
    },
    hideSensitiveData: {
        type: Boolean,
        default: false,
    },
});

const travelDate = computed(() => {
    if (!props.activeRedemption?.start_date) return '';
    return dayjs(props.activeRedemption.start_date).format('MMM D, YYYY');
});
</script>
